// src/components/VerificationModal.js
import { Dialog, DialogTitle, DialogContent, DialogActions, Box ,CircularProgress} from "@mui/material";
import CustomText, { textStyles } from "../../../components/CustomText";
import CustomButton from "../../../components/CustomButton";
import { useTheme } from "@mui/material/styles";
import warning from "../../../assets/warning.svg"
const VerificationModal = ({  open, onClose, message, onContinue, loading  }) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth 
      PaperProps={{
    sx: { borderRadius: "14px" ,py:3,px:2,
          // ✔ Add margin-top only on small screens
      mt: { xs: 4, sm: 0 }, 
      } // ✅ custom radius
  }}>
    <Box sx={{display:"flex",justifyContent:"center",mt:1, mb:1, }}>
    <img src={warning} style={{width:90,height:90}}/>
    </Box>
      <DialogTitle>
        <CustomText sx={{ ...textStyles.h4,fontSize:"22px", color: theme.palette.tertiary.main,letterSpacing:"0px !important" }}>
          Verification Required
        </CustomText>
      </DialogTitle>

      <DialogContent>
        <CustomText sx={{ ...textStyles.body4, color: theme.palette.text.primary }}>
        Your account has not been verified. Please check your email for the verification link. Didn’t receive it?
        </CustomText>
      </DialogContent>

      <DialogActions>
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          {/* <CustomButton label="Resend OTP" onClick={onContinue}  /> */}
          <CustomButton
  onClick={onContinue}
  disabled={loading}
  label={
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      {loading && (
        <CircularProgress size={18} sx={{ color: "#fff", mr: 1 }} />
      )}
      Resend OTP
    </Box>
  }
/>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default VerificationModal;
